import { getJPaths } from "./getJPaths.js";
/**
 * Recursively extracts all JSON paths with their corresponding primitive values from an object.
 * @param obj - The input object or value to traverse.
 * @param options - Optional parameters to control traversal and filtering.
 * @returns an object mapping jpaths to their corresponding primitive values.
 */
export function getJPathsAsObject(obj, options = {}) {
    const jpaths = getJPaths(obj, options);
    const result = {};
    for (const entry of jpaths) {
        result[entry.jpath] = entry.value;
    }
    return result;
}
//# sourceMappingURL=getJPathsAsObject.js.map